import { prefixRelativeUrl } from '../util.js';

$(function () {
    const currentContentId = $('#site-menu-lg > ul').data('current-contentid');

    const generateRightHtml = function (item) {
        return `<div class="dropdown-item-container border border-medium border-white ${
            item.IsActive ? 'active' : ''
        }"><a class="dropdown-item text-wrap"
              href="${prefixRelativeUrl(item.Url)}" 
              data-contentid="${item.ContentId}">${item.Title}</a></div>`;
    };

    // Handling of the "Mega menu", which is a Bootstrap dropdown
    $('#site-menu-lg .nav-item.dropdown').on('show.bs.dropdown', (event) => {
        const contentId = $(event.relatedTarget).data('contentid');
        const $menu = $(event.target).find('.dropdown-menu');

        $('body').addClass('backdrop');
        $('header').css('position', 'relative');
        $('header').css('z-index', '1120');

        $menu.find('.right-panel').addClass('d-none');

        $menu.find('.dropdown-item.active').removeClass('active');

        $.getJSON(
            prefixRelativeUrl(`/__navigation/menuitems/${contentId}/${currentContentId}`)
        ).done((data) => {
            var children = null;

            const markup = data
                .map((item) => {
                    if (item.Children !== null) {
                        children = item.Children;
                    }
                    return `<div class="dropdown-item-container d-flex flex-row justify-content-between border border-medium border-white ${
                        item.IsActive || item.IsAncestor ? 'active' : ''
                    }"><a class="dropdown-item text-wrap"
              href="${prefixRelativeUrl(item.Url)}">${item.Title}</a>
              ${
                  item.HasChildren
                      ? `<button class="dropdown-item dropdown-menu-button-icon populate-right border-left border-medium border-white" data-contentid="${
                            item.ContentId
                        }" aria-label="Undermeny för ${
                            item.Title
                        }"><svg viewBox="0 0 24 24" class="caret" aria-hidden="true">
                    <use href="${prefixRelativeUrl(
                        '/dist/spritemap.svg#sprite-caret-right'
                    )}"></use>
                </svg>`
                      : ''
              }</button></div>`;
                })
                .join('');

            $menu.find('.left-panel .dropdown-items-mount').html(markup);

            if (children !== null && children !== undefined) {
                var itemMarkup = children.map((childItem) => generateRightHtml(childItem)).join('');

                $menu.find('.right-panel').removeClass('d-none');

                $menu.find('.right-panel .dropdown-items-mount').html(itemMarkup);

                $menu.find('.right-panel .dropdown-item').first().focus();
            }
        });
    });

    $('#site-menu-lg .nav-item.dropdown').on('hide.bs.dropdown', (event) => {
        $('body').removeClass('backdrop');
        $('header').css('position', '');
        $('header').css('z-index', '');
    });

    const populateRight = function ($target, $parent) {
        $('.left-panel .active').removeClass('active');
        $parent.addClass('active');

        const contentId = $target.data('contentid');
        const href = $parent.find('a').first().attr('href');
        const title = $parent.find('a').first().text();
        const $menu = $target.closest('.dropdown-menu');

        $.getJSON(prefixRelativeUrl(`/__navigation/menuitems/${contentId}`))
            .done((data) => {
                //const headingMarkup =
                //    `<div class="dropdown-item-container border border-medium border-white"><a class="dropdown-item text-wrap font-weight-bold" href="${href}">${title}</a></div>`;
                const itemMarkup = data.map((item) => generateRightHtml(item)).join('');

                $menu.find('.right-panel').removeClass('d-none');

                $menu.find('.right-panel .dropdown-items-mount').html(itemMarkup);
            })
            .done((_) => {
                $menu.find('.right-panel .dropdown-item').first().focus();
            });
    };

    $('#site-menu-lg').on('click', '.left-panel .dropdown-item.populate-right', (event) => {
        event.preventDefault();
        event.stopPropagation();

        var currentTarget = $(event.currentTarget);
        populateRight(currentTarget, currentTarget.parent());
    });

    $('#site-menu-lg').on('keyup', '.left-panel .dropdown-item.populate-right', (event) => {
        if (event.key === 'ArrowRight') {
            var currentTarget = $(event.currentTarget);
            populateRight(currentTarget, currentTarget.parent());
        }
    });

    $('#site-menu-lg').on('keyup', '.right-panel .dropdown-item', (event) => {
        if (event.key === 'ArrowLeft') {
            $(event.target).closest('.dropdown-menu').find('.left-panel .active a').focus();
        }
    });
});
